import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chips", "option", "cycleCard", "panel"]

  connect() {
    const readonly = this.optionTargets.some(o => o.disabled || o.readOnly)
    this.optionTargets.forEach(option => {
      if (option.checked) {
        this.#addChip(option.value, option.dataset.label, readonly)
        this.#showCycleCard(option.value)
      }
    })
  }

  toggleDropdown() {
    this.panelTarget.classList.toggle("hidden")
  }

  check(event) {
    const checkbox = event.target
    if (checkbox.checked) {
      this.#addChip(checkbox.value, checkbox.dataset.label)
      this.#showCycleCard(checkbox.value)
    } else {
      this.#removeChip(checkbox.value)
      this.#hideCycleCard(checkbox.value)
    }
  }

  remove(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.chipValue
    const option = this.optionTargets.find(o => o.value === value)
    if (option) option.checked = false
    this.#removeChip(value)
    this.#hideCycleCard(value)
  }

  #addChip(value, label, readonly = false) {
    if (this.chipsTarget.querySelector(`[data-chip-value="${value}"]`)) return
    const chip = document.createElement("span")
    chip.className = "chip"
    chip.dataset.chipValue = value
    if (readonly) {
      chip.textContent = label
    } else {
      chip.innerHTML = `${label} <button type="button" class="chip-remove" data-action="click->autoclave-chips#remove" data-chip-value="${value}" aria-label="Remove ${label}">&times;</button>`
    }
    this.chipsTarget.appendChild(chip)
  }

  #removeChip(value) {
    const chip = this.chipsTarget.querySelector(`[data-chip-value="${value}"]`)
    if (chip) chip.remove()
  }

  #showCycleCard(value) {
    const card = this.cycleCardTargets.find(c => c.dataset.showWhen === value)
    if (!card) return
    card.classList.remove("hidden")
    requestAnimationFrame(() => card.classList.remove("opacity-0", "translate-y-2"))
  }

  #hideCycleCard(value) {
    const card = this.cycleCardTargets.find(c => c.dataset.showWhen === value)
    if (!card) return
    card.classList.add("opacity-0", "translate-y-2")
    card.addEventListener("transitionend", () => card.classList.add("hidden"), { once: true })
  }
}
